import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { FullPageSpinner } from '@/components/etainabl-spinner';
import { useReleaseNoteEdition } from '@/queries/releaseNotes';
import { EditionArticle } from './EditionArticle';
import { markEditionSeen } from './useSeenEditions';

export function ReleaseNoteEditionView({ editionKey, asUser }: { editionKey: string; asUser?: string }) {
  const { data, isLoading, error } = useReleaseNoteEdition(editionKey, asUser);

  // Only the reader's own visits clear the dot, never a staff lens.
  useEffect(() => {
    if (data && !asUser) markEditionSeen(data.key);
  }, [data, asUser]);

  if (isLoading) return <FullPageSpinner srLabel="Loading release notes" />;

  const back = (
    <Link
      to="/release-notes"
      className="inline-flex items-center gap-1.5 text-etn-control-sm font-semibold text-etn-text-label hover:text-etn-text"
    >
      <ArrowLeft className="h-3.5 w-3.5" aria-hidden />
      Release notes
    </Link>
  );

  if (error || !data) {
    return (
      <div className="container mx-auto max-w-3xl space-y-4 p-6">
        {back}
        <p className="text-sm text-etn-text-label">These release notes aren’t available.</p>
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto max-w-5xl space-y-6 px-6 pb-16 pt-6">
        {back}
        <EditionArticle edition={data} />
      </div>
    </>
  );
}
